import { Space, Tag } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxTable, { TableColumnsType } from 'components/RevxTable';
import { ContactAddress } from 'domains/orgDomain';
import React from 'react';
import { useTranslation } from 'react-i18next';

const AddrNestedTable = (props: {
  contactId: number;
  defaultAddressId: number;
}) => {
  const { t } = useTranslation();
  const columns: TableColumnsType<ContactAddress> = [
    {
      title: t('common.id'),
      dataIndex: 'id',
      fixed: 'left',
    },
    {
      title: t('platform.org.addr.table.columns.default'),
      dataIndex: 'id',
      render: (value, record) =>
        value === props.defaultAddressId && (
          <Tag color={'green'}>{t('common.default')}</Tag>
        ),
    },
    {
      title: t('platform.org.addr.table.columns.addressLine1'),
      dataIndex: 'addressLine1',
    },
    {
      title: t('platform.org.addr.table.columns.addressLine2'),
      dataIndex: 'addressLine2',
    },
    {
      title: t('platform.org.addr.table.columns.city'),
      dataIndex: 'city',
    },
    {
      title: t('platform.org.addr.table.columns.state'),
      dataIndex: 'state',
    },
    {
      title: t('platform.org.addr.table.columns.country'),
      dataIndex: 'country',
    },
    {
      title: t('platform.org.addr.table.columns.postalCode'),
      dataIndex: 'postalCode',
    },
    {
      title: t('platform.org.addr.table.columns.phoneNumber'),
      dataIndex: 'phoneNumber',
    },
    {
      title: t('common.createdAt'),
      dataIndex: 'createAt',
      valueType: 'time',
    },
    {
      title: t('common.actions'),
      key: 'actions',
      fixed: 'right',
      render: (value, record) => (
        <Space size="small">
          <RevxButton
            type="link"
            size="small"
            key="view"
            onClick={() =>
              dispatch.org.setState({
                curAddr: { ...record, contactId: props.contactId },
              })
            }
          >
            {t('common.view')}
          </RevxButton>
        </Space>
      ),
    },
  ];

  const dispatch = useAppDispatch();

  // table data processing
  const data = useAppSelector(
    (state) =>
      state?.org?.contacts?.content.find((c) => c.id === props.contactId)
        ?.addresses || []
  );
  const loading = useAppSelector(
    (state) => state.loading.effects.org.getContacts
  );

  return (
    <RevxTable<ContactAddress>
      showHeader={false}
      loading={loading}
      columns={columns}
      dataSource={data}
      pagination={false}
      key={props.contactId}
      size="small"
      width="calc(100vw - 64px)"
      minWidth={1376}
      scrollWidth={1376}
    />
  );
};

export default AddrNestedTable;
